export namespace CommonTranslations {
  export const common = {
    confirm: 'confirm',
    confirmed: 'confirmed',
    reject: 'reject',

    ownership: 'ownership',

    image: 'image',
  } as const;

  export const internal = {
    format: 'format',
    horizontalMargin: 'horizontalMargin',
    verticalMargin: 'verticalMargin',

    configurationName: 'configurationName',
    configurationNamePlaceholder: 'configurationNamePlaceholder',
  } as const;

  export const upload = {
    fileUploadDropFilesToUpload: 'fileUploadDropFilesToUpload',
    fileUploadSelectFiles: 'fileUploadSelectFiles',
    fileUploadSupportedFileFormats: 'fileUploadSupportedFileFormats',
    fileUploadSelectImagesOrDragAndDrop: 'fileUploadSelectImagesOrDragAndDrop',
    fileUploadRemoveFile: 'fileUploadRemoveFile',
  } as const;
}
